import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TPostSegmentDeclaration, TSegmentDeclaration } from '../types';

export async function postSegmentDeclaration(
  body: TPostSegmentDeclaration
): Promise<TSegmentDeclaration> {
  return mediaManagerClient
    .post('/api/v1/segment_declarations', emptyStringValues(body))
    .then(response => response as unknown as TSegmentDeclaration);
}

type MutationFn = typeof postSegmentDeclaration;

type TUsePostSegmentDeclarationParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePostSegmentDeclaration({ config }: TUsePostSegmentDeclarationParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: postSegmentDeclaration,
    onError(error) {
      addErrorNotification(t('No se ha podido crear la declaración del segmento'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('La declaración del segmento se ha creado correctamente'));
    },
  });
}
